module.exports = __webpack_public_path__ + "static/media/thumbnail-jumaria.f828bc32.jpeg";